var isVisibleClass = "is-visible";
var isActiveClass = "is-active";
var topBar = document.getElementById('Topbar-info');

var currentSubMenu = null;

  function showSubMenu(submenuId) {
    if (currentSubMenu) {
      currentSubMenu.style.display = 'none';
    }

    currentSubMenu = document.getElementById(submenuId);
    currentSubMenu.style.display = 'flex';
    currentSubMenu.style.flexDirection = 'column';
    currentSubMenu.style.width = '100%';
    currentSubMenu.style.background = '#FEFEFE';
    currentSubMenu.style.zIndex = '399';
    currentSubMenu.style.overflowY = 'scroll';
    
    document.querySelectorAll('.main-category').forEach(category => {
     /*category.style.display = 'none';*/
    });
    document.querySelectorAll('.back-button').forEach(backButton => {
      backButton.style.display = 'flex';
    });
  }

  function goBack() {
    if (currentSubMenu) {
      currentSubMenu.style.display = 'none';
      currentSubMenu = null;
    }

    document.querySelectorAll('.main-category').forEach(category => {
      category.style.display = 'flex';
       category.style.flexDirection  = 'row';
    });
    document.querySelectorAll('.back-button').forEach(backButton => {
      backButton.style.display = 'none';
    });
  }


var tabcontent = document.getElementsByClassName("tabcontent");
    tabcontent[0].style.display = "flex";
    tabcontent[0].style.flexDirection = "column";
    tabcontent[0].style.zIndex = "400";
    tabcontent[0].style.height = "100%";
    tabcontent[0].style.minHeight = "400px";


var tabBtn = document.getElementsByClassName("tablinks");
    //tabBtn[0].className += " active";
    
function openMenuTab(evt, menuName) {
  // Declare all variables
  var i, tabcontent, tablinks;

    
  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
   
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(menuName).style.display = "flex";
  document.getElementById(menuName).style.flexDirection = "column";
  document.getElementById(menuName).style.minHeight = "400px";
  evt.currentTarget.className += " active";
}

        //Check Login 
var status = document.body.classList.contains( 'logged-in' );

if(status == 'true'){    // If Logged In then
    jQuery('div > div > div > div.panel__scroller.v-stack.gap-8 > div.Footermobile > li:nth-child(3) > a').text("Konto");
   jQuery('div > div > div > div.panel__scroller.v-stack.gap-8 > div.Footermobile > li:nth-child(3) > a').attr("href", "{{ routes.account_url }}");
}
else{                   // If user is not Logged In Then
    jQuery('div > div > div > div.panel__scroller.v-stack.gap-8 > div.Footermobile > li:nth-child(3) > a').text("Anmelden");
    jQuery('div > div > div > div.panel__scroller.v-stack.gap-8 > div.Footermobile > li:nth-child(3) > a').attr("href", "{{ routes.account_url }}");
}

//Set auto Screen-Height
function setDynamicHeight() {
  var content = document.querySelector('.navigation-drawer');
  var windowHeight = window.innerHeight;
  content.style.maxHeight = `${windowHeight}px`;
}
// Set initial height and listen for window resize
setDynamicHeight();
window.addEventListener('resize', setDynamicHeight);


//Lock and Fix Body Background, when mobile Menu is open
function lockScroll() {
   var body = document.body;
   var scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
  body.style.position = "sticky";
  body.style.overflow = "hidden";
  
  body.style.top = `-${scrollY}`;
}

function unlockScroll() {
   var body = document.body;
   var scrollY = body.style.top;
  body.style.overflow = "";
  body.style.position = "";
  body.style.top = "";
  window.scrollTo(0, parseInt(scrollY || '0') * -1);

      }
  window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
});  